module.exports = __webpack_public_path__ + "static/media/closedCookie.5d5169e7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/fortuneCookie/closedCookie.webp
// module id = 1482
// module chunks = 0